import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { debounceTime, filter } from 'rxjs/operators';
import { DireccionService } from 'src/app/services/direccion.service';
import { MaquinaInventarioService } from 'src/app/services/maquina-inventario.service';
import * as _ from 'lodash'
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { Subscription } from 'apollo-client/util/Observable';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-maquinas-inventario-cliente',
  templateUrl: './maquinas-inventario-cliente.component.html',
  styleUrls: ['./maquinas-inventario-cliente.component.scss'],
  providers: [SecurityService]
})
export class MaquinasInventarioClienteComponent implements OnInit {

  formHeader: FormGroup;

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent

  // Data & Tmp
  public rutEmpresa: number
  public sucursalCodigo: number
  loading: boolean = false
  listaMaquinas: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  cliente: any = null
  currentPayload: any

  optionsSucursal: Array<any> = [];

   //TODO: VARIABLES PARA SCROLL
   currentPayLoad: any;
   totalRegistrosPos: any;
   totalPagPos: any;
   PagPosActual: any;
   notEmptyPost = true;
   notscrolly = true;
   subscription: Subscription;
   private scrollHeight = 100;
   private PageNum = 1;
   showButton = false;
   showButtonDown: boolean;


  // Utils
  private log: any

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private spinner: NgxSpinnerService,
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private vendedorService: VendedorService,
    private direccionService: DireccionService,
    private maquinaInventarioService: MaquinaInventarioService,
    private fileDownloadService: FileDownloadService,
  ) {
    this.log = this.clog.log('MAQUINAS')

    this.onScrollTop();
  }

  @HostListener('window:scroll')
  onWindowsScroll(): void{
    const yOffSet = window.pageYOffset;
    const scrollTop = this.document.documentElement.scrollTop;

    //* MOSTRAR U OCULTAR BOTONES DE AYUDA SCROLL
    if(this.listaMaquinas != null){
      this.showButton = (yOffSet || scrollTop) > this.scrollHeight;
      this.showButtonDown = (yOffSet || scrollTop) >= 0
    }

  }

  //* LA BARRA DEL SCROLL QUEDA AL INICIO AL INGRESAR A LA VISTA - SCROLL CON BOTON SUBIR
  onScrollTop():void{
    this.document.documentElement.scrollTop = 0;
  }

  //* SE PUEDE REALIZAR UN SCROLL A TRAVES DEL BOTON BAJAR
  onScrollAbajo():void{
    this.document.documentElement.scrollBy(0,1000)

  }

  //* AL REALIZAR EL SCROLL HACIA ABAJO SE AGREGAN LOS SIGUIENTES 100 DATOS DE LA PAGINA SGTE
  onScrollDown(e):void{
    console.log(e);
    const inputParams = _.cloneDeep(this.currentPayLoad);
    console.log(inputParams);
    if(inputParams != undefined || inputParams != null){
      console.log("entro aqui");
      delete inputParams.paginaActual
      this.PageNum += 1
      inputParams.paginaActual = this.PageNum;

    this.spinner.show();
    if(this.notscrolly && this.notEmptyPost){
      console.log("entra aqui", this.notscrolly, this.notEmptyPost);
      self.document.getElementById("spinnerX").style.display = "block";

      this.maquinaInventarioService.GetSegunFiltroCliente(inputParams);

      this.maquinaInventarioService.queryCliente.subscribe((data: any[])=>{
        this.PagPosActual = data[0].obtenerSegunFiltroClienteExcel.respuesta.paginaActual
        this.totalPagPos = data[0].obtenerSegunFiltroClienteExcel.respuesta.totalPaginas
        this.totalRegistrosPos = data[0].obtenerSegunFiltroClienteExcel.respuesta.totalRegistros
        this.listaMaquinas.push(...data[0].obtenerSegunFiltroClienteExcel.respuesta.registros);
        // console.log("Dame los siguientes datos del paginado",this.listOfCliente)
        this.spinner.hide()
        self.document.getElementById("spinnerX").style.display = "block";
         if(data[0].obtenerSegunFiltroClienteExcel.respuesta.paginaActual === data[0].obtenerSegunFiltroClienteExcel.respuesta.totalPaginas){
          this.notEmptyPost = false;
          self.document.getElementById("spinnerX").style.display = "none";
        }
        if(data[0].obtenerSegunFiltroClienteExcel.respuesta.registros.length < data[0].obtenerSegunFiltroClienteExcel.respuesta.cantidadRegistrosPorPagina){
          self.document.getElementById("spinnerX").style.display = "none";
          this.PagPosActual = 1
        }
         this.notscrolly = true;

      })
    }
    }
  }


  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.createForms()
    this.formChangesSubscriptions()
  }

  private createForms() {
    this.formHeader = this.fb.group({
      rutCliente: [null], //, [Validators.required]],
      sucursal: [null, []]
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente)
      })
  }

  openModalSeleccionarcliente() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data, origen }) {
    this.cliente = data
    this.cliente.rutFormato = this.rutService.AgregarDV(this.cliente.rut)
    this.formHeader.get('rutCliente').setValue(this.cliente.rutFormato)
    this.fetchSucursal(this.cliente.rut)
  }

  onClienteNoEncontrado() {
    this.cliente = null
  }

  private fetchSucursal(cliente_proveedor_rut) {
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      // sucursal_codigo: this.sucursalCodigo,
      cliente_proveedor_rut
    }

    this.log('fetch sucursal', JSON.stringify(inputParams))
    this.direccionService.GetByCliente(inputParams, ({ registros }) => {
      this.optionsSucursal = registros.map(direccion => ({
        value: direccion.codigo,
        label: direccion.nombre,
        ...direccion
      }))
      // this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('sucursal'), this.optionsSucursal)
    })
  }

  buscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber
    const self = this; // this is unused

    this.listaMaquinas = []
    const { sucursal } = this.formHeader.value
    const inputParams = {
      filtro: {
        exacto: {
          empresa_rut: this.rutEmpresa,
          rut_cliente: this.rutService.QuitarDV((this.formHeader.get('rutCliente').value) || 0),
        }
      },
      sucursal: sucursal,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: 20
    }
    this.currentPayLoad = _.cloneDeep(inputParams);

    this.log('inputParams', JSON.stringify(inputParams))

    // this.loading = true
    // this.maquinaInventarioService.obtenerSegunFiltroCliente(inputParams, ({ mensajes, respuesta }) => {
    //   const ok = respuesta !== null
    //   if (!ok) {
    //     this.messageRendererService.showErrors(mensajes)
    //     return
    //   }

    //   const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
    //   this.paginationContext.RecordsCount = totalRegistros
    //   this.paginationContext.CurrentPage = paginaActual
    //   this.paginationContext.PagesCount = totalPaginas
    //   this.listaMaquinas = registros
    //   this.loading = false
    // })


    this.spinner.show();
      this.maquinaInventarioService.GetSegunFiltroCliente(inputParams);

      this.maquinaInventarioService.queryCliente.subscribe((data: any[])=>{
        this.PagPosActual = data[0].obtenerSegunFiltroClienteExcel.respuesta.paginaActual
        this.totalPagPos = data[0].obtenerSegunFiltroClienteExcel.respuesta.totalPaginas
        this.totalRegistrosPos = data[0].obtenerSegunFiltroClienteExcel.respuesta.totalRegistros
        this.listaMaquinas = data[0].obtenerSegunFiltroClienteExcel.respuesta.registros.slice(0,20);
        this.listaMaquinas.forEach(mov => {
        mov.rutFormato_cliente = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
        mov.rutFormato_proveedor = this.rutService.AgregarDV(mov.proveedor_rut)
        })

        this.spinner.hide();
        if(data[0].obtenerSegunFiltroClienteExcel.respuesta.paginaActual === data[0].obtenerSegunFiltroClienteExcel.respuesta.totalPaginas){
          self.document.getElementById("spinnerX").style.display = "none";
         }
      })
      this.notscrolly = true;
      this.notEmptyPost = true;
      this.PageNum = 1;
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayLoad)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.filtro.exacto.retornaExcel = type === 'XLS'
    inputParams.filtro.exacto.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.maquinaInventarioService.obtenerSegunFiltroClienteExcelPdf(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
}
